import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { tokens } from "../../styles/tokens";

interface PasswordStrengthResult {
  strength: number;
  strengthColor: string;
  strengthText: string;
}

export function usePasswordStrength(password: string): PasswordStrengthResult {
  const { t } = useTranslation();

  const strength = useMemo(() => {
    if (!password) return 0;
    let s = 0;
    if (password.length >= 8) s += 1;
    if (/\d/.test(password)) s += 1;
    if (/[a-z]/.test(password)) s += 1;
    if (/[A-Z]/.test(password)) s += 1;
    if (/[^A-Za-z0-9]/.test(password)) s += 1;
    return s;
  }, [password]);

  const strengthColor = useMemo(() => {
    if (strength <= 1) return tokens.err;
    if (strength <= 3) return tokens.warn;
    return tokens.indigo600;
  }, [strength]);

  const strengthText = useMemo(() => {
    if (strength <= 1) return t("weak");
    if (strength <= 2) return t("fair");
    if (strength <= 3) return t("good");
    if (strength <= 4) return t("strong");
    return t("veryStrong");
  }, [strength, t]);

  return { strength, strengthColor, strengthText };
}
